module.exports = __webpack_public_path__ + "static/assets/458a2499a574553aa5cc5bd882b0d6a6.gif";